import Menu from "./Menu";
import { drinksMenu } from "../mock";

export default function DrinksMenu() {
  return (
    <Menu
      menuData={drinksMenu}
      title="DRINKS MENU"
      subtitle="Crafted Cocktails | Premium Spirits | Fine Wines"
      showTableMenuDownload
      downloadMenuUrl="/image/siteimages/drinksmenu/download/Final%20Sea%20Spice%20Kitchen%20-%20Premium%20Drinks%20Menu%20(HD%20Print).pdf"
      downloadLabel="Download Drinks Menu (PDF)"
      heroImage="/image/siteimages/gallery/restaurantPhotos/Photo%202.png"
    />
  );
}
